<template>
     <span v-if="businesses">             
      <ul class="ul-layout">
          <li class="li-layout" :key="index" v-for="(business,index) in businesses">
              <business-info-layout :business="{id:index, name:business.name,shortname:business.shortname||'',address:business.address||''}"> 
                  <businesses-layout-item>
                    <slot name="buttons" :business="{id:index, name:business.name,shortname:business.shortname||'',address:business.address||''}"></slot>
                  </businesses-layout-item>
              </business-info-layout>
          </li>
      </ul>    
    </span>
</template>

<script>
export default {      
  props:["businesses"],
  data: function() {
    return {
       
    };
  },
  methods: {}
};
</script>
 


// WEBPACK FOOTER //
// src/components/shared/controls/layouts/BusinessesLayout.vue